<template>
  <div class="tfa-code" :class="[`tfa-code--${theme}`]">
    <input
      v-for="(number, index) in tfaCode"
      :ref="`tfaCode${index}`"
      v-model="tfaCodeEdit[index]"
      :key="index"
      @input="checkCodeValue(index)"
      @keyup="checkKeyPress($event, index)"
      @keyup.enter="$emit('submit')"
      type="number"
    />
  </div>
</template>

<script>
const BACKSPACE = 8;
const DELETE = 46;

export default {
  props: {
    tfaCode: {
      type: Array,
      required: true
    },
    theme: {
      default: 'dark'
    }
  },
  data() {
    return {
      tfaCodeEdit: []
    };
  },
  mounted() {
    this.$nextTick(() => this.$refs.tfaCode0[0].select());
    this.tfaCodeEdit = this.tfaCode;
  },
  methods: {
    checkCodeValue(index) {
      const value = this.tfaCode[index];
      if (value.length === 1 && this.$refs[`tfaCode${index + 1}`]) {
        this.$refs[`tfaCode${index + 1}`][0].select();
      } else if (value.length === this.tfaCode.length) {
        value.split('').forEach((char, index) => {
          this.tfaCodeEdit[index] = char;
        });
      }
    },
    checkKeyPress($event, index) {
      if ($event.keyCode === BACKSPACE) {
        const moveTo = index > 0 ? index - 1 : 0;
        this.$refs[`tfaCode${moveTo}`][0].select();
      }
    }
  }
};
</script>

<style lang="scss">
@import '@sass/_variables.scss';
.tfa-code {
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }
  input {
    display: inline-block !important;
    width: 13.5% !important;
    border: 1px solid !important;
    text-align: center;
    font-size: 30px !important;
    border-radius: 6px !important;

    &:not(:last-of-type) {
      margin-right: 10px !important;
    }
  }

  &--white {
    input {
      color: white;
      border-color: white !important;
      background-color: $symptoms-black-accent !important;
    }
  }
}
</style>
